import { SidebarNavMenuService } from './shared/core-rms/sidebar-nav-menu.service';
import { MenuService } from './shared/core-rms/rms.menu.service';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { AppComponent } from './app.component';
import { UiNdmsModule } from '../../shared/ui-ndms/ui-ndms.module';
import { UiRmsModule } from './shared/ui-rms/ui-rms.module';
import { CoreRmsModule } from './shared/core-rms/core-rms.module';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { AuthModule, OidcSecurityService } from "angular-auth-oidc-client";
import { CoreModule } from "../../shared/core/core.module";
import { SaveSearchService } from "../../shared/core/services/save-search.service";

import {
  appNameFactory,
  appPathFactory,
  getBaseUrl,
  identityUrlFactory,
  siteMode,
  userGuides
} from "./app.module.browser";
import { SidebarNavService } from './shared/core-rms/sidebar-nav.service';
import { LeftNavResolverGuard } from '../../shared/core/services/left-nav-resolver-guard';
import { CurrentEventResolverGuard } from './events/shared/current-event-resolver.guard';
import { ChangeEventComponent } from './components/current-event/change-event/change-event.component';
import { UserGuideActivationGuard } from './shared/core-rms/user-guide-activation.guard';

const providers = [
  OidcSecurityService,
  MenuService,
  SidebarNavService,
  SidebarNavMenuService,
  LeftNavResolverGuard,
  CurrentEventResolverGuard,
  UserGuideActivationGuard,
  SaveSearchService,
  { provide: 'BASE_URL', useFactory: getBaseUrl },
  { provide: 'ORIGIN_URL', useFactory: getBaseUrl },
  { provide: 'IDENTITY_URL', useFactory: identityUrlFactory },
  { provide: 'APP_PATH', useFactory: appPathFactory },
  { provide: 'APP_NAME', useFactory: appNameFactory },
  { provide: 'SITE_MODE', useFactory: siteMode },
  { provide: 'USER_GUIDES', useFactory: userGuides}
];

// @ts-ignore
@NgModule({
  declarations: [
    AppComponent,
    ChangeEventComponent
  ],
  entryComponents: [ChangeEventComponent],
  providers: providers,
  imports: [
    CommonModule,
    CoreRmsModule,
    CoreModule,
    CheckboxModule,
    CalendarModule,
    UiNdmsModule,
    UiRmsModule,
    AuthModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
  ]
})
export class AppModuleShared { }
@NgModule({})
export class RmsAppModuleShared {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AppModuleShared,
      providers: providers
    }
  }
}
